import { render, staticRenderFns } from "./regAccount.vue?vue&type=template&id=60f4398d&scoped=true&"
import script from "./regAccount.vue?vue&type=script&lang=js&"
export * from "./regAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f4398d",
  null
  
)

export default component.exports